import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getJournalPost } from "../lib/api";
import { Reveal } from "../components/Reveal";

export default function JournalPost() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); getJournalPost(slug).then(setData); }, [slug]);
  if (!data) return <div className="min-h-screen flex items-center justify-center font-serif text-2xl">Loading…</div>;
  const { post, more } = data;

  return (
    <article data-testid="journal-post-page">
      <div className="relative h-[60vh] min-h-[440px] overflow-hidden">
        <img src={post.image} alt={post.title} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative container-luxe h-full flex flex-col justify-end pb-14 text-bone max-w-4xl">
          <p className="overline text-bone/80 mb-4">{post.category} · {post.read_time}</p>
          <h1 className="h-display text-4xl sm:text-6xl">{post.title}</h1>
          <p className="mt-5 overline text-[11px] text-bone/70">By {post.author} · {post.date}</p>
        </div>
      </div>

      <div className="container-luxe py-16 max-w-2xl">
        <Reveal>
          <p className="font-serif text-2xl font-light leading-relaxed mb-8">{post.excerpt}</p>
          {post.body.split("\n\n").map((para, i) => (
            <p key={i} className="text-base text-charcoal/80 font-light leading-loose mb-6">{para}</p>
          ))}
          <div className="flex flex-wrap gap-2 mt-10 pt-8 border-t border-hairline">
            {post.tags?.map((t) => <span key={t} className="overline text-[10px] text-muted-foreground border border-hairline px-3 py-1">#{t}</span>)}
          </div>
        </Reveal>
      </div>

      <section className="bg-beige/40 py-20">
        <div className="container-luxe">
          <h2 className="h-display text-3xl sm:text-4xl mb-10">Keep Reading</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {more.map((m) => (
              <Link key={m.id} to={`/journal/${m.slug}`} className="group block" data-testid={`more-${m.slug}`}>
                <div className="aspect-[4/3] overflow-hidden bg-beige mb-4"><img src={m.image} alt={m.title} className="h-full w-full object-cover img-zoom" /></div>
                <p className="overline text-[10px] text-gold mb-2">{m.category}</p>
                <h3 className="font-serif text-xl group-hover:text-gold transition-colors">{m.title}</h3>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </article>
  );
}
